import React, { useEffect, useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import { getTotalTransactionAmount } from '../calculations/getTotalTransactionAmount';
import { getSuccessfulTopUpCount } from '../calculations/successfulTopUp';
import GetUserCount from '../calculations/getUserCount';
import OperatorsCount from '../calculations/OperatorsCount';

const DashBoardCardsOne = () => {
    const [totalAmount, setTotalAmount] = useState({});
    const [successfulCount, setSuccessfulCount] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            const amount = await getTotalTransactionAmount();
            const count = await getSuccessfulTopUpCount();
            setTotalAmount(amount);
            setSuccessfulCount(count);
        };

        fetchData();
    }, []);

    const cards = [
        {
            title: 'Total Transactions',
            value: (
                <div style={{ fontSize: '15px', lineHeight: '1.4', marginTop: '4px' }}>
                    {Object.keys(totalAmount).length > 0 ? (
                        Object.entries(totalAmount).map(([currency, amount]) => (
                            <div key={currency} className="d-flex justify-content-between">
                                <span className="me-2" style={{ fontWeight: 500 }}>{currency}:</span>
                                <span>{amount.toFixed(2)}</span>
                            </div>
                        ))
                    ) : (
                        <span>0.00</span>
                    )}
                </div>
            ),
        },
        {
            title: 'Successful Top-Ups',
            value: <span>{successfulCount}</span>,
        },
        {
            title: 'User',
            value: <span><GetUserCount /></span>,
        },
        {
            title: 'Operators',
            value: <span><OperatorsCount /></span>,
        },
    ];

    return (
        <section className="py-4 nav-body-bg" style={{ marginTop: '70px' }}>
            <Container fluid>
                <Row className="g-4 justify-content-center text-center">
                    {cards.map((card, idx) => (
                        <div key={idx} className="card-widheit">
                            <div className="rounded-3 py-2 text-start px-4 theme-card">
                                <small className="body-text-three card-title-label">{card.title}</small>
                                <h5 className="text-h2 mt-2 card-value">{card.value}</h5>
                            </div>
                        </div>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default DashBoardCardsOne;
